import userSessionStorage from './userSessionStorage'

export default function getUserInfo() {
  const session = new userSessionStorage()
  if (!session) {
    return null
  }

  return session.getUserInfo()
}
